export class Store {
	state = undefined;
	callbacks = [];

	constructor(initState = undefined) {
		this.state = initState;
	}

	subscribe = callback => {
		this.callbacks.push(callback);

		return () => {
			this.callbacks = this.callbacks.filter(cb => cb !== callback);
		};
	};

	setState = newState => {
		this.state = newState;
		this.callbacks.forEach(callback => callback(this.state));
	};
}
